import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { UsersState, DestinationUser } from './types';
import * as myetaapi from '@/api/myeta';

export const state: UsersState = {
    users: []
};

export const actions: ActionTree<UsersState, GlobalState> = {
    async reload({ commit }, param) {
        const users = await myetaapi.getUsers(param);
        commit('setUsers', {
            users
        });
    },

    async create({ commit }, payload) {
        const startLink = await myetaapi.createUser(payload.destinationId, payload.name);
        commit('userCreated');
    },

    async remove({ commit }, payload) {
        await myetaapi.removeUser(payload.destinationId, payload.userId);
        commit('userRemoved', payload);
    },
};

export const mutations: MutationTree<UsersState> = {
    setUsers(state, payload) {
        state.users = payload.users;
        console.log('set users', state.users);
    },

    userCreated(state, payload) {
        console.log('user created');
    },

    userRemoved(state, payload) {
        state.users = (state.users || []).filter((val) => {
            return val != payload;
        });
        console.log('user removed');
    },
};

export const getters: GetterTree<UsersState, GlobalState> = {
    currentUsers(state): DestinationUser[] | null {
        return state.users;
    },
};

const namespaced: boolean = true;
export const users: Module<UsersState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
